import React, { useContext } from 'react';

import PageContentItem from './PageContentItem';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import { PageContentStateContext } from '@src/contexts/wysiwyg/page_content';

function SvgPage() {
  const {
    renderableArea: renderArea,
    svgRef,
    viewbox
  } = useContext(WysiwygEditorStateContext);

  const { contentItems } = useContext(PageContentStateContext);

  return (
    <svg
      viewBox={`0 0 ${viewbox.height} ${viewbox.width}`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
    >
      <g>
        <defs>
          <clipPath id="clip-render-area">
            <rect
              x={renderArea.x * viewbox.width}
              y={renderArea.y * viewbox.height}
              height={renderArea.height * viewbox.height}
              width={renderArea.width * viewbox.width}
            />
          </clipPath>
        </defs>
        <g clipPath="url(#clip-render-area)">
          {contentItems.map((item) => (
            <PageContentItem data={item} key={item.id} />
          ))}
        </g>
      </g>
    </svg>
  );
}

export default SvgPage;
